import { PdfPreview } from "@circle-react/components/shared/AttachmentPreview/PdfPreview";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Modal } from "@circleco/compass/components/Modal";

import { t } from "@/i18n-js/instance";
import type { CompassModalProps } from "@/react/components/SettingsApp/CompassCompat/modalHelpers";

import type { FilePreviewModalProps } from "./types";

export const FilePreviewModalComponent = ({
  file,
  open,
  onOpenChange,
}: FilePreviewModalProps & CompassModalProps) => {
  const isPDF = file.content_type === "application/pdf";
  if (!isPDF) return null;

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="full-screen">
      <Modal.Content>
        <Modal.Header
          title={file.filename}
          suffix={
            <IconButton
              aria-label={t("download")}
              icon="arrow-box-down"
              variant="ghost"
              size="sm"
              renderLink={
                <a href={file.url} download aria-label={t("download")} />
              }
            />
          }
        />
        <Modal.Body customLayout>
          <PdfPreview className="size-full" src={file.url} />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
